import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { createCompany, searchLegalCompany, searchPhysicalCompany, updateCompany } from "@services/http/settings";
import { CompanyStoreActions, CompanyStoreProps } from "./Company.types";

export const useCompanyStore = create<CompanyStoreProps & CompanyStoreActions>()(
  devtools(set => ({
    isLoading: false,

    createCompany: async data => {
      set({ isLoading: true });

      try {
        await createCompany(data);
      } finally {
        set({ isLoading: false });
      }
    },

    searchLegalCompany: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await searchLegalCompany(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    searchPhysicalCompany: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await searchPhysicalCompany(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    updateCompany: async data => {
      set({ isLoading: true });

      try {
        await updateCompany(data);
      } finally {
        set({ isLoading: false });
      }
    },

    setIsLoading: state => set({ isLoading: state }),
  }))
);
